import { useIntl } from "react-intl";
import { SkinProductKey } from "~/api/models/SkinProductKey";
import { useFetchProducts } from "~/api/salesForce/useFetchProducts";
import ProductCard from "~/components/organisms/Pricing/ProductCard/ProductCard";
import useDefaultProduct from "~/hooks/useDefaultProduct";

const MesotherapySkinCard = () => {
  const intl = useIntl();
  const { data: allProducts, isLoading } = useFetchProducts();

  const defaultProduct = useDefaultProduct(allProducts.skin.mesotherapySkin);

  return (
    <ProductCard
      skinProductFamilyKey={SkinProductKey.mesotherapySkin}
      defaultProduct={defaultProduct}
      cardTitle={intl.formatMessage({
        id: "pricing.mesotherapySkin",
      })}
      options={allProducts.skin.mesotherapySkin}
      blankOptionTitle={intl.formatMessage({
        id: "treatment.pricing.mesotherapySkin.none",
      })}
      modalTitle={intl.formatMessage({
        id: "pricing.mesotherapySkin",
      })}
      isLoading={isLoading}
    />
  );
};

export default MesotherapySkinCard;
